import Notify from "../classes/notify";
import I18n from "../classes/translations";

// disable Dropzones auto discover
Dropzone.autoDiscover = false;

/**
 * Class which initalizes custom dropzones to upload files
 */

export default class CustomDropzones {
	constructor() {
		this.addRemoveLinks = true;
		this.removePost = 'dropzone-remove-file';
		this.notify = new Notify();
	}

	initializeDefaultDropzones() {
		this.productGroupDefaultFiles();
	}

	productGroupDefaultFiles() {
		this.defaultDropzone('#js-product-group-default-files');
		this.productDocumentsDropzone();
	}

	/**
	 * Initialize the default used dropzone function
	 *
	 * @param {string} id - id from html element
	 */

	defaultDropzone(id) {
		const dropzoneId = id;
		const $dropzoneDom = $(dropzoneId);
		const dropzoneRemoveFilePost = $dropzoneDom.data(this.removePost);

		if ($dropzoneDom.length && dropzoneRemoveFilePost) {
			const dropzone = new Dropzone(dropzoneId, {
				addRemoveLinks: this.addRemoveLinks,
				removedfile: function (file) {
					$.post(dropzoneRemoveFilePost, {filename: file.name}, function () {
						$(document).find(file.previewElement).remove();
					})
				}
			});

			if (dropzone) {
				this._getUploadedFilesAndInsert('files/list-all', dropzone);
			}
		}
	}

	/**
	 * Get already uploaded files and insert it into the dropzone
	 *
	 * @param {string} json
	 * @param dropzone
	 * @private
	 */

	_getUploadedFilesAndInsert(json, dropzone) {
		$.getJSON(json, function (data) {
			$.each(data, function (index, val) {
				const mockFile = {
					name: val.name,
					size: val.size,
					dataURL: window.location.href + '/' + val.name,
					accepted: true,
				};

				dropzone.options.addedfile.call(dropzone, mockFile);
				dropzone.options.thumbnail.call(dropzone, mockFile, 'files/' + val.name);
				dropzone.emit("complete", mockFile);
			});
		});
	}

	productDocumentsDropzone() {
		const that = this;

		const dropzoneClass = '.js-product-documents-dropzone';
		const $dropzonesDom = $(dropzoneClass);
		const translations = I18n.global();

		if ($dropzonesDom.length) {
			$dropzonesDom.each(function () {
				const $dropzone = $(this);
				const dropzoneId = $dropzone.attr('id');

				const dropzone = new Dropzone(`#${dropzoneId}`, {
					// acceptedFiles: 'application/pdf,application/docx',
					init: function () {
                        this.on("processing", function(file) {
                            dropzone.options.url = $dropzonesDom.attr('action');
                        });
						this.on('success', function (file, response) {
							response.forEach(function (values) {
								that._addFileTableRow(
									$dropzone.parents('.js-dropzone-file-table-container').find('.js-product-documents-table'),
									values
								);

								that.notify.notify(translations.fileUploadSuccess, 'success');
							})
						});
						this.on('error', function (file, response) {
							that.notify.notify(translations.fileUploadFailure, 'danger');
						})
					}
				});
			});
		}
	}

	_addFileTableRow(table, file) {

		let filePreview;

		if (file.fileType == 'pdf') {
			filePreview = '<i class="la la-file-pdf-o"></i>';
		} else if (file.fileType == 'docx') {
			filePreview = '<i class="la la-file-word-o"></i>';
		} else if (file.fileType == 'png' || file.fileType == 'jpg') {
			filePreview = `<img class="file__img" src="${file.name}" alt="${file.name}" />`;
		} else {
			filePreview = '<i class="la la-file-o"></i>';
		}

		let input = `<input class="form-control m-input" type="text" data-file="${file.fileId}" value="${file.name}" name="fileName[${file.languageId}][${file.fileId}]">`;

        if(file.tabName !== undefined) {
        	input = `<input class="form-control m-input js-test" type="text" data-file="${file.fileId}" value="${file.name}" name="fileName[${file.languageId}][${file.tabName}][${file.fileId}]">`;
		}

		const tableRowTemplate = `
		<tr>
			<td>
				${filePreview}
			</td>
			<td>
				${file.name}
			</td>
			<td>
				${input}
			</td>
			<td>
				<label class="m-checkbox m-checkbox--single">
					<input type="checkbox" name="deleteFile[${file.languageId}][${file.fileId}]" value="1">
					<span></span>
				</label>
			</td>
			<td class="handle">
                                      BEWEG DICH!
                                    </td>
		</tr>`;

		table.find('tbody').append(tableRowTemplate);
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/dropzone.js